import { useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { api, errMsg, fileUrl } from "@/lib/api";

const Slot = ({ title, hint, fid, fallback, onUpload, testid }) => {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads", fd);
      await onUpload(data.id);
      toast.success(`${title} atualizado`);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="card-tech p-6" data-testid={testid}>
      <p className="font-heading text-lg font-bold uppercase text-white">{title}</p>
      <p className="text-xs text-slate-500">{hint}</p>
      <div className="mt-4 flex h-48 items-center justify-center overflow-hidden border border-slate-700 bg-black/40">
        {fid ? <img src={fileUrl(fid)} alt={title} className="max-h-full max-w-full object-contain" data-testid={`${testid}-preview`} /> : fallback}
      </div>
      <label className={`btn-red mt-4 cursor-pointer ${busy ? "pointer-events-none opacity-60" : ""}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Enviar imagem
        <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      </label>
    </div>
  );
};

export const AdminBranding = () => {
  const { config, loadConfig } = useApp();
  const b = config?.branding || {};
  const save = async (patch) => { await api.put("/admin/branding", { ...b, ...patch }); await loadConfig(); };
  return (
    <div className="grid gap-6 md:grid-cols-2" data-testid="admin-branding">
      <Slot title="Logotipo oficial" hint="PNG com fundo transparente recomendado. Exibido no cabeçalho e na ordem de serviço." fid={b.logo_file_id}
        fallback={<img src="/img/logo-nillo.jpg" alt="Logo atual" className="h-full object-contain" />} onUpload={(id) => save({ logo_file_id: id })} testid="branding-logo" />
      <Slot title="Imagem do veículo desmontado" hint="Usada na tela inicial para representar a desmontagem técnica." fid={b.vehicle_file_id}
        fallback={<img src="/img/carro-desmontado.jpg" alt="Imagem atual" className="h-full w-full object-cover opacity-70" />} onUpload={(id) => save({ vehicle_file_id: id })} testid="branding-vehicle" />
    </div>
  );
};
